module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upsell-container upsell-container-parent",
    attrs: {
      "id": "parent"
    }
  }, [_c('div', {
    staticClass: "upsell-container content-start",
    attrs: {
      "id": "prices"
    }
  }, [(_vm.showDifference) ? _c('span', {
    staticClass: "upsell-container f5 fw5",
    attrs: {
      "id": "prices-percentage"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.formattedPercentage) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.showDifference) ? _c('span', {
    staticClass: "price-amounts text-grey fw4",
    attrs: {
      "id": "prices-retail"
    }
  }, [_vm._v(_vm._s(_vm.formattedRetailPrice))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "current-container pr3 fw5"
  }, [_c('span', {
    staticClass: "price-amounts",
    attrs: {
      "id": "prices-current"
    }
  }, [_vm._v(_vm._s(_vm.formattedCurrentPrice))]), _vm._v(" "), _c('span', [_vm._v("/ Month")])])]), _vm._v(" "), _c('div', {
    staticClass: "inter f7 fw5 text-grey",
    attrs: {
      "id": "prices-description"
    }
  }, [_c('p', [_vm._v("Billed on the same interval as your primary subscription (" + _vm._s(this.interval) + ")")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28c7b962","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/upsell/UpsellPrices.vue
// module id = 1013
// module chunks = 0